/* @flow */
import cx from 'classnames';
import * as React from 'react';

import Box from 'components/Box.jsx';
import BoxBody from 'components/BoxBody.jsx';
import Container from 'components/Container.jsx';
import UnauthenticatedView from './UnauthenticatedView.jsx';

export class AuthenticationView extends React.Component<{
  children?: React.Node,
  className?: string,
  size: 'large' | 'medium' | 'small' | 'xsmall',
}> {
  static defaultProps = {
    size: 'xsmall',
  };

  render() {
    const { className, size, ...props } = this.props;

    return (
      <UnauthenticatedView {...props} className={cx('AuthenticationView', className)}>
        <Container size={size}>
          <Box>
            <BoxBody>{this.props.children}</BoxBody>
          </Box>
        </Container>
      </UnauthenticatedView>
    );
  }
}

export default AuthenticationView;
